import React, { useState, useEffect } from 'react';
import getFacility from '../../shared/api/getFacility';

const Main: React.FC = () => {
  const [facility, setFacility] = useState({
    name: '',
    address1: '',
    address2: '',
    phone: '',
    fax: '',
    representativeName: ''
  });

  useEffect(() => {
    const fetchFacility = async () => {
      try {
        const response = await getFacility();
        setFacility(response.data.facility);
      } catch (error) {
        console.error("Error fetching facility data:", error);
      }
    };

    fetchFacility();
  }, []);

  return (
    <React.Fragment>
      <main id="page-facility_login" className="wrapper">
        <section className="sec-contact">
          <div className="inner">
            <h1 className="c-ttl__01">施設基本情報の確認</h1>
            <div className="contact-box">
              <div className="contact-box__left">
                <div className="mbpc-98 mbsp-32">
                  <div className="contact-box__form js-item" id="id-01">
                    <div className="contact-box__item">
                      <label className="contact-box__ttl"><span>施設名</span></label>
                      <div className="contact-box__ct">
                        <p className="contact-box__desc">{facility.name}</p>
                      </div>
                    </div>
                    <div className="contact-box__item">
                      <label className="contact-box__ttl"><span>住所</span></label>
                      <div className="contact-box__ct">
                        <p className="contact-box__desc">{facility.address1}<br />{facility?.address2 ?? ''}</p>
                      </div>
                    </div>
                    <div className="contact-box__item">
                      <label className="contact-box__ttl"><span>電話番号</span></label>
                      <div className="contact-box__ct">
                        <p className="contact-box__desc">{facility.phone}</p>
                      </div>
                    </div>
                    <div className="contact-box__item">
                      <label className="contact-box__ttl"><span>Fax番号</span></label>
                      <div className="contact-box__ct">
                        <p className="contact-box__desc">{facility?.fax}</p>
                      </div>
                    </div>
                    <div className="contact-box__item mbpc-20 mbsp-20">
                      <label className="contact-box__ttl"><span>担当者名</span></label>
                      <div className="contact-box__ct">
                        <p className="contact-box__desc">{facility?.representativeName}</p>
                      </div>
                    </div>
                    <p className="c-ttl__02"><span>※施設基本情報の変更は弊社担当営業へお申し出ください。</span></p>
                  </div>
                  <a href="/facility/top" className="c-btn__01 c-btn__01--white row">トップ画面へ戻る</a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default Main;
